'use strict';

import logger from './logger.js';

const clickEventNamespace = 'click.parkersCompareLink';
const prepopVrmDataAttribute = 'data-parkers-compare-prepop-vrm';

const setLinkUrl = ($targetLink, jwtToken) => {
	const linkParams = new URLSearchParams($targetLink[0].search);
	if (jwtToken) {
		linkParams.set('prepopQuoteJwt', jwtToken);
	}

	$targetLink[0].search = linkParams.toString();
	$targetLink.removeAttr(prepopVrmDataAttribute);
}

const getJwtPrePopulationToken = async ($targetLink, vrm) => {
	const data = {
		vrm: vrm
	};

	await $.ajax({
		url: '/api/insurance-links/fetch-token',
		method: 'post',
		contentType: 'application/json',
		data: JSON.stringify(data),
		timeout: 3000, // 3 second timeout
		success: (result) => {
			setLinkUrl($targetLink, result);
		},
		error: (error) => {
			logger.warn('Error getting Parkers Compare JWT Token: ' + error);
		}
	});
}

const handleCompareLinkClick = async (event) => {
	const $target = $(event.target);
	const vrmToPrePopulate = $target.attr(prepopVrmDataAttribute);
	if (vrmToPrePopulate) {
		event.preventDefault();
		await getJwtPrePopulationToken($target, vrmToPrePopulate);
		event.target.click(); // We want it to open in a new window but JS may be blocked as popup so reclicking the link instead
	}
}

export default {
	init: () => {
		const $compareLinks = $(`a[${prepopVrmDataAttribute}]`);
		$compareLinks.off(clickEventNamespace).on(clickEventNamespace, handleCompareLinkClick);
	},
}